export default __webpack_public_path__ + "static/media/BaranLogo.0c34ef45.png";